import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { getFlowTag, getUserId } from '../../../redux/slices/userSlice'
import { paramsToQuery } from '../../../utils/historyDecorators'
import { MoneyBack } from '../../common'

import './styles.scss'

const Footer = () => {
	const user_id = useSelector(getUserId)
	const flow_tag = useSelector(getFlowTag)

	return (
		<div className={`discount-footer ${flow_tag === '' ? 'legal' : ''}`}>
			<img
				src="/images/sale/footer-logos.png"
				alt="discount-footer-logos"
				className="discount-footer__logos"
			/>
			<div className="discount-footer-links">
				<a
					href="https://mail.google.com/mail/?view=cm&fs=1&to=support@refineapp.co"
					className="link"
					target="_blank"
					rel="noreferrer"
				>
					Contact Us
				</a>
				<Link
					className="link"
					to={{
						pathname: '/privacy-policy',
						search: paramsToQuery({ user_id }),
					}}
				>
					Privacy policy
				</Link>
				<Link
					className="link"
					to={{
						pathname: '/terms-of-use',
						search: paramsToQuery({ user_id }),
					}}
				>
					Terms of Service
				</Link>
			</div>
			<MoneyBack />
			<span className="discount-footer__adress">
				GM Unicorn Corporation Limited Florinis 7, Greg Tower,2nd Floor, 1065,
				Nicosia, Cyprus
			</span>
		</div>
	)
}

export { Footer }
